<template lang="pug">
  .breadcrumbs(v-if="activeMenuItems.ancestors.length")
    .panel
      template(v-for="ancestor in activeMenuItems.ancestors")
        Ancestor(
          :key="ancestor.id"
          :item="ancestor"
        )
        .divider /
      .current-item {{ activeMenuItems.current.title }}
</template>

<script>
import { mapGetters } from 'vuex';

import { get, cloneDeep } from '@/helpers';
import NestedSet from '@/nested-set-lib';

import Ancestor from './Ancestor';

export default {
    name: 'BreadcrumbNav',
    components: {
        Ancestor
    },
    computed: {
        activeMenuItems() {
            let activeItems = {
                current: undefined,
                ancestors: []
            };

            let items;
            const check = path => {
                this.menus.forEach(menu => {
                    if (activeItems.current) return;

                    items = get(menu, 'menuItems') || [];
                    activeItems.current = items.find(el => el.path === path);
                });
            };

            if (this.$route.name === 'product-details') {
                let path = '/';

                // NOTE: can not get from SetupAPI .. apollo error
                const history = JSON.parse(window.sessionStorage.getItem('history')) || [];
                if (history.length) {
                    history.forEach(path => {
                        if (activeItems.current) return;
                        check(path);
                    });
                } else {
                    check(path);
                }
            } else {
                const path = this.$route.path;
                check(path);
            }

            if (activeItems.current) {
                activeItems.ancestors = NestedSet.getAncestors(cloneDeep(items), activeItems.current);
                // activeItems = [...ancestors, item];

                if (this.activeProduct && this.$route.name === 'product-details') {
                    activeItems.ancestors.push(activeItems.current);
                    activeItems.current = { title: this.activeProduct.name };
                }
            }

            return activeItems;
        },
        ...mapGetters({
            menus: 'menus',
            activeProduct: 'shop/activeProduct'
        })
    }
};
</script>

<style lang="sass" scoped>

.breadcrumbs
  display: none
  padding: 1rem 3rem
  @screen lg
    display: block
  .panel
    @apply flex rounded-none shadow-none
    padding: 0
    background: none
    a
      font-weight: bold
      // text-transform: uppercase
      &:hover,
      &:active
        text-decoration: underline
    div
      @apply text-gray-600
      font-weight: bold
      // text-transform: uppercase
    .divider
      margin: 0 .5rem
</style>
